/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown> }} Ui_Weather_WindInputs */

const en_ui_weather_wind = /** @type {(inputs: Ui_Weather_WindInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wind ${i?.range}`)
};

const de_ui_weather_wind = /** @type {(inputs: Ui_Weather_WindInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wind ${i?.range}`)
};

/**
* | output |
* | --- |
* | "Wind {range}" |
*
* @param {Ui_Weather_WindInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_wind = /** @type {((inputs: Ui_Weather_WindInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_WindInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_wind(inputs)
	return de_ui_weather_wind(inputs)
});